import { SOCIAL_AD_TYPES } from "utils/constants";
import { MEGA } from "utils/common";

import { isURL, maxLength, requiredNotNull } from "widgets/forms/validators/validators";
import { creativeNameAllowedChars, creativeNameMaxLength } from "widgets/forms/validators/Creatives";
import { filesize, duration, dimensions } from "widgets/forms/validators/Assets";
import {
	requiredAsset,
	errorMessageReducer
} from "./validators";

export const TWITTER_VIDEO_CONSTRAINTS = {
	MAX_LENGTH_HEADLINE: 70,
	MAX_LENGTH_TWEET: 280,
	MAX_LENGTH_LANDING_PAGE: 800,
	MAX_VIDEO_MB: 512,
	DURATION: { max: 140 },
	VIDEO_ACCEPT: ".mp4, .mov",
};

export function twitterVideoWarning(allValues, props) {
	const {
		MAX_LENGTH_HEADLINE,
		MAX_LENGTH_TWEET,
		MAX_LENGTH_LANDING_PAGE,
		MAX_VIDEO_MB,
		DURATION,
	} = TWITTER_VIDEO_CONSTRAINTS;

	const formName = SOCIAL_AD_TYPES.TWITTER_VIDEO;
	const values = allValues[formName] || {};

	const warn = {
		headline: [requiredNotNull, maxLength(MAX_LENGTH_HEADLINE)],
		tweet: [requiredNotNull, maxLength(MAX_LENGTH_TWEET)],
		landingPage: [requiredNotNull, isURL, maxLength(MAX_LENGTH_LANDING_PAGE)],
		video: [requiredAsset, filesize({ max: MAX_VIDEO_MB * MEGA }), duration(DURATION)],
	};

	return errorMessageReducer(warn, values, formName);
}

export function twitterVideoValidator(allValues, props) {
	const formName = SOCIAL_AD_TYPES.TWITTER_VIDEO;
	const values = allValues[formName] || {};

	const validators = {
		name: [requiredNotNull, creativeNameMaxLength, creativeNameAllowedChars],
	};

	return errorMessageReducer(validators, values, formName);
}


export const TWITTER_IMAGE_CONSTRAINTS = {
	MAX_LENGTH_HEADLINE: 70,
	MAX_LENGTH_TWEET: 280,
	MAX_LENGTH_LANDING_PAGE: 800,
	MAX_IMAGE_MB: 5,
	IMAGE_ACCEPT: ".jpeg, .jpg, .png",
	DIMENSIONS: {
		minWidth: 800,
	},
};

export function twitterImageWarning(allValues, props) {
	const {
		MAX_LENGTH_HEADLINE,
		MAX_LENGTH_TWEET,
		MAX_LENGTH_LANDING_PAGE,
		MAX_IMAGE_MB,
		DIMENSIONS,
	} = TWITTER_IMAGE_CONSTRAINTS;

	const formName = SOCIAL_AD_TYPES.TWITTER_IMAGE;
	const values = allValues[formName] || {};

	const warn = {
		headline: [requiredNotNull, maxLength(MAX_LENGTH_HEADLINE)],
		tweet: [requiredNotNull, maxLength(MAX_LENGTH_TWEET)],
		landingPage: [requiredNotNull, isURL, maxLength(MAX_LENGTH_LANDING_PAGE)],
		image: [requiredAsset, filesize({ max: MAX_IMAGE_MB * MEGA }), dimensions(DIMENSIONS)],
	};

	return errorMessageReducer(warn, values, formName);
}

export function twitterImageValidator(allValues, props) {
	const formName = SOCIAL_AD_TYPES.TWITTER_IMAGE;
	const values = allValues[formName] || {};

	const validators = {
		name: [requiredNotNull, creativeNameMaxLength, creativeNameAllowedChars],
	};

	return errorMessageReducer(validators, values, formName);
}

export function twitterCarouselWarning(allValues, props){
	return {
		[SOCIAL_AD_TYPES.TWITTER_CAROUSEL]: {
			landingPage: "PLACEHOLDER DELETE ME",
		},
	};
}

export function twitterCarouselValidator(allValues, props){
	return {
		[SOCIAL_AD_TYPES.TWITTER_CAROUSEL]: {
			landingPage: "PLACEHOLDER DELETE ME",
		},
	};
}
